import { render } from "./Tendency.vue?vue&type=template&id=76321904&scoped=true"
import script from "./Tendency.vue?vue&type=script&lang=js"
export * from "./Tendency.vue?vue&type=script&lang=js"

import "./Tendency.vue?vue&type=style&index=0&id=76321904&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76321904"]])

export default __exports__